import { gql } from '@apollo/client'
import { ADMIN_WHOLE_AUDIT_FRAGMENT } from '../fragments'

export const GET_ADMIN_STORE_AUDIT = gql`
  query GetAdminStoreAudit($auditId: ID!) {
    audit(auditId: $auditId) {
      ...AdminWholeAudit
    }
  }
  ${ADMIN_WHOLE_AUDIT_FRAGMENT}
`
